import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { SpeedIcon, GearboxIcon, CalendarIcon, EngineIcon } from 'shared/components/Icons';

import PriceUah from 'shared/components/PriceUah/PriceUah';
import PriceUsdEuro from 'shared/components/PriceUsdEuro/PriceUsdEuro';
import { getPriceBySlug } from 'shared/helpers/transportInfo';

// import LeasingWithCalculatorButton from 'shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton';
// import MicroCreditButton from 'shared/components/LeasingOnlineBanner/MicroCreditButton/MicroCreditButton';
import LeasingButtonWrapper from 'shared/components/LeasingOnlineBanner/LeasingButtonWrapper/LeasingButtonWrapper';

import { isAnyLeasingAvailable } from 'shared/helpers/leasing/leasing';

import s from './PromoutedLeasingCard.css';

class PromoutedLeasingCard extends React.Component {
  static propTypes = {
    fullPrice: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    year: PropTypes.number.isRequired,
    make: PropTypes.shape().isRequired,
    maker: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
    model: PropTypes.shape().isRequired,
    mileageText: PropTypes.string,
    engineTitle: PropTypes.string,
    gearboxTitle: PropTypes.string,
    shouldEmphasizePrice: PropTypes.bool,
    isNegotiablePrice: PropTypes.bool,

    advert: PropTypes.shape().isRequired,
    priceUAH: PropTypes.string,
    priceUSD: PropTypes.string,
    priceEUR: PropTypes.string,
    index: PropTypes.number,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    fullPrice: null,
    mileageText: null,
    engineTitle: '',
    gearboxTitle: '',
    abroadTitle: '',
    drivenFromTitle: '',
    shouldEmphasizePrice: false,
    isNegotiablePrice: false,
    priceUAH: '0',
    priceUSD: '0',
    priceEUR: '0',
    index: 0,
  };

  render() {
    const {
      advert,
      fullPrice,
      year,
      mileageText,
      engineTitle,
      gearboxTitle,
      make,
      maker,
      model,
      shouldEmphasizePrice,
      isNegotiablePrice,
      intl,
      priceUAH,
      priceUSD,
      priceEUR,
      index,
    } = this.props;

    const isLeasing = isAnyLeasingAvailable(advert);

    const priceTheme = isLeasing ? 'small' : 'yellow';

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.title}>
            {(maker && maker.title) || (make && make.title)} {model && model.title}
          </div>
          <div className={s.info}>
            {year &&
              <span>
                <CalendarIcon />
                {year}
              </span>}
            {mileageText &&
              <span>
                <SpeedIcon />
                {mileageText}
              </span>}
          </div>
          <div className={s.info}>
            {engineTitle &&
              <span>
                <EngineIcon />
                {engineTitle || ''}
              </span>}
            {gearboxTitle &&
              <span>
                <GearboxIcon />
                {gearboxTitle || ''}
              </span>}
          </div>
        </div>
        {/* {isLeasing &&
          !isNegotiablePrice &&
          <div className={s.leasingButton}>
            <LeasingWithCalculatorButton advert={advert} index={index} />
          </div>}
        {isMicrocredit &&
          !isNegotiablePrice &&
          <div className={s.leasingButton}>
            <MicroCreditButton advert={advert} index={index} />
          </div>} */}

        {isLeasing &&
          !isNegotiablePrice &&
          <div className={s.leasingButton}>
            <LeasingButtonWrapper advert={advert} index={index} />
          </div>}
        <PriceUah uah={getPriceBySlug(advert.price, 'uah')} theme={priceTheme} />
        {!isNegotiablePrice &&
          <PriceUsdEuro
            usd={getPriceBySlug(advert.price, 'usd')}
            eur={getPriceBySlug(advert.price, 'eur')}
          />}

        {isNegotiablePrice &&
          <div className={cx(s.price)}>
            {intl.formatMessage({ id: 'договорная' })}
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(PromoutedLeasingCard);



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertCarCard/PromoutedLeasingCard/PromoutedLeasingCard.js